import { _, J, G, K } from "main/jsxRuntime.module";
function r() {
  return (r = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }).apply(this, arguments);
}
var i = ["context", "children"];
function a(t) {
  this.getChildContext = function() {
    return t.context;
  };
  var e = t.children, n = function(t2, e2) {
    if (null == t2) return {};
    var n2, o, r2 = {}, i2 = Object.keys(t2);
    for (o = 0; o < i2.length; o++) e2.indexOf(n2 = i2[o]) >= 0 || (r2[n2] = t2[n2]);
    return r2;
  }(t, i);
  return K(e, n);
}
function s() {
  var o = new CustomEvent("_preact", { detail: {}, bubbles: true, cancelable: true });
  this.dispatchEvent(o), this._vdom = _(a, r({}, this._props, { context: o.detail.context }), function e(n, o2) {
    if (3 === n.nodeType) return n.data;
    if (1 !== n.nodeType) return null;
    var r2 = [], i2 = {}, a2 = 0, s2 = n.attributes, l2 = n.childNodes;
    for (a2 = s2.length; a2--; ) "slot" !== s2[a2].name && (i2[s2[a2].name] = s2[a2].value, i2[c(s2[a2].name)] = s2[a2].value);
    for (a2 = l2.length; a2--; ) {
      var u2 = e(l2[a2], null), d = l2[a2].slot;
      d ? i2[d] = _(p, { name: d }, u2) : r2[a2] = u2;
    }
    var h = o2 ? _(p, null, r2) : r2;
    return _(o2 || n.nodeName.toLowerCase(), i2, h);
  }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? J : G)(this._vdom, this._root);
}
function c(t) {
  return t.replace(/-(\w)/g, function(t2, e) {
    return e ? e.toUpperCase() : "";
  });
}
function l(t, e, r2) {
  if (this._vdom) {
    var i2 = {};
    i2[t] = r2 = null == r2 ? void 0 : r2, i2[c(t)] = r2, this._vdom = K(this._vdom, i2), G(this._vdom, this._root);
  }
}
function u() {
  G(this._vdom = null, this._root);
}
function p(e, n) {
  var o = this;
  return _("slot", r({}, e, { ref: function(t) {
    t ? (o.ref = t, o._listener || (o._listener = function(t2) {
      t2.stopPropagation(), t2.detail.context = n;
    }, t.addEventListener("_preact", o._listener))) : o.ref.removeEventListener("_preact", o._listener);
  } }));
}
function register(t, e, n, o) {
  function r2() {
    var e2 = Reflect.construct(HTMLElement, [], r2);
    return e2._vdomComponent = t, e2._root = o && o.shadow ? e2.attachShadow({ mode: o.mode || "open" }) : e2, e2;
  }
  return (r2.prototype = Object.create(HTMLElement.prototype)).constructor = r2, r2.prototype.connectedCallback = s, r2.prototype.attributeChangedCallback = l, r2.prototype.disconnectedCallback = u, n = n || t.observedAttributes || Object.keys(t.propTypes || {}), r2.observedAttributes = n, n.forEach(function(t2) {
    Object.defineProperty(r2.prototype, t2, { get: function() {
      return this._vdom.props[t2];
    }, set: function(e2) {
      this._vdom ? this.attributeChangedCallback(t2, null, e2) : (this._props || (this._props = {}), this._props[t2] = e2, this.connectedCallback());
      var n2 = typeof e2;
      null != e2 && "string" !== n2 && "boolean" !== n2 && "number" !== n2 || this.setAttribute(t2, e2);
    } });
  }), customElements.define(e || t.tagName || t.displayName || t.name, r2);
}
export {
  register as r
};
